import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    user: null,
    companyType: [
        {
            text: 'SJL',
            value: 'SJL',
        },
        {
            text: 'SHARP',
            value: 'SHARP',
        },
        {
          text: 'SHARP_TDOC',
          value: 'SHARP_TDOC',
      },
        {
            text: '海外取引先',
            value: 'PARTNER',
        },
        {
            text: '得意先',
            value: 'OVERSEAS'
        },
        {
            text: 'サプライヤー',
            value: 'SUPPLIER',
        },
        {
            text: '生産拠点',
            value: 'PRODUCTION_BASE',
        },
        {
            text: 'バイヤー',
            value: 'BUYER',
        },
        {
            text: '乙仲',
            value: 'CUSTOMS_AGENT',
        },
    ],
    shippingModes: [{
        text: 'SEA',
        value: 'TPM_SEA'
    },
    {
        text: 'AIR',
        value: 'TPM_AIR'
    },
    {
        text: 'Truck',
        value: 'TPM_ROAD'
    },
    {
        text: 'RAIL',
        value: 'TPM_RAIL'
    },
    {
        text: 'SEA & AIR',
        value: 'TPM_MUL'
    },
    ],
    sku_classifications: [{
            text: '完成品',
            value: 1
        },
        {
            text: '部件',
            value: 2
        },
        {
            text: 'サービスパーツ',
            value: 3
        },
        {
            text: 'その他',
            value: 4
        }
    ],
    skuClassifications: [{
            text: '完成品',
            value: '完成品'
        },
        {
            text: '部件',
            value: '部件'
        },
        {
            text: 'サービスパーツ',
            value: 'サービスパーツ'
        },
        {
            text: 'その他',
            value: 'その他'
        }
    ],
    stages: [{
            name: 'INV P/L登録', //this.$t('B0300.titles[0]'),
            to: 'B0300'
        },
        {
            name: 'S/A登録', //this.$t('B0400.title'),
            to: 'B0400'
        },
        {
            name: 'BL確認完了送信',
            to: 'B1600'
        },
        {
            name: '納入指示メール配信',
            to: 'B0500'
        },
        {
            name: '事前仮予約',
            to: 'B2200'
        },
        {
            name: '倉庫別予約一覧',
            to: 'B2300'
        },
        {
            name: '納入指示',
            to: 'B0600'
        },
        {
            name: '受入確認',
            to: 'B0700'
        },
        {
            name: 'フレイトI/V作成',
            to: 'B1000'
        },
        {
            name: 'D/O確定',
            to: 'B0800'
        },
        {
            name: 'EIAJ',
            to: 'B0900'
        },
        {
            name: '諸掛費用登録',
            to: 'B1100'
        },
        {
            name: '月次処理・請求',
            to: 'B1200'
        },
        {
            name: '売掛金回収',
            to: 'B1400'
        },
        {
            name: 'BL確認完了照会',
            to: 'B1601'
        },
        {
            name: '月次運賃ハンド対応一覧',
            to: 'B2000'
        },
        {
            name: '純無償請求書',
            to: 'B2100'
        },
        {
            name: '海外請求書発行',
            to: 'B2400'
        }
        // { name: 'PO変更・取消一覧', to: '/B1800' },
        // { name: 'PreSA・本SA相違一覧', to: '/B1900' }
    ],
    deliveryDirectorHeader: [{
            text: '事業本部',
            value: 'buId',
            sortable: false
        },
        {
            text: '事業部',
            value: 'departmentId',
            sortable: false
        },
        {
            text: '品種',
            value: 'productCode',
            sortable: false
        },
        {
            text: '部品区分',
            value: 'classification',
            sortable: false
        },
        {
            text: '納入指示担当1',
            value: 'deliveryDirectorId1',
            sortable: false
        },
        {
            text: '納入指示担当2',
            value: 'deliveryDirectorId2',
            sortable: false
        },
        {
            text: '納入指示担当3',
            value: 'deliveryDirectorId3',
            sortable: false
        },
        {
            text: '納入指示担当4',
            value: 'deliveryDirectorId4',
            sortable: false
        },
        {
            text: '納入指示担当5',
            value: 'deliveryDirectorId5',
            sortable: false
        },
        {
            text: '納入指示担当6',
            value: 'deliveryDirectorId6',
            sortable: false
        },
        {
            text: '納入指示担当7',
            value: 'deliveryDirectorId7',
            sortable: false
        },
        {
            text: '納入指示担当8',
            value: 'deliveryDirectorId8',
            sortable: false
        }
    ]
}

const options = {
    state,
    mutations,
    actions,
    getters
}

const store = new Vuex.Store(options)


export default store